// extracted by mini-css-extract-plugin
module.exports = {"illustrationContainer":"flexible-views_illustrationContainer__9I66o","illustration":"flexible-views_illustration__PR3JY","headerContainer":"flexible-views_headerContainer__w8fdH"};